import React from 'react'

const LocationIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="locationGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 120, 120, 1)" />
          <stop offset="50%" stopColor="rgba(230, 90, 90, 1)" />
          <stop offset="100%" stopColor="rgba(200, 60, 60, 1)" />
        </linearGradient>
        <filter id="locationGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Pin shape */}
      <path 
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
        fill="url(#locationGradient)"
        filter="url(#locationGlow)"
      />
      
      {/* Inner circle */}
      <circle 
        cx="12" 
        cy="9" 
        r="2.5" 
        fill="rgba(255, 255, 255, 0.8)"
      />
    </svg>
  )
}

export default LocationIcon
